import { usePermissionsStore } from "@/stores/permissionsStore";

const usePermissions = () => {
  const permissionsStore = usePermissionsStore();
  const { user } = useAuth();
  const role = user.value?.role;

  /**
   * Parses a permission string in the format 'entity.action'.
   * @param {string} permission - The permission string to parse (e.g., 'user.read').
   * @returns {{ entity: string, action: string }} An object containing the entity and action.
   */
  const parsePermission = (permission) => {
    const [entity, action] = permission.split(".");
    return { entity, action };
  };

  const permissionExists = (permission) => {
    const { entity, action } = parsePermission(permission);

    if (permissionsStore.permissions[role] === undefined) {
      console.error("Permission role does not exist:", role);
      return false;
    }

    if (permissionsStore.permissions[role][entity] === undefined) {
      console.error("Permission entity does not exist:", entity);
      return false;
    }

    if (permissionsStore.permissions[role][entity][action] === undefined) {
      console.error("Permission action does not exist:", action);
      return false;
    }

    return true;
  };

  /**
   * Check if the user has a specific permission
   * @param {*} permission
   * @returns true if the user has the permission
   * @returns false if the user does not have the permission or the permission does not exist
   */
  const can = (permission) => {
    if (!permissionExists(permission)) {
      return false;
    }

    const { entity, action } = parsePermission(permission);
    return permissionsStore.permissions[role][entity][action];
  };

  return {
    can,
  };
};

export default usePermissions;
